import * as React from 'react';
import { createRoot } from 'react-dom/client';
import NotificationsContainer from './NotificationsContainer'

const NotificationsRoot = (props) => {
    return <NotificationsContainer {...props} />;
}

export default NotificationsRoot;

if(typeof window.NotificationsRoots == 'undefined') {
    window.NotificationsRoots = {};
}

// MOUNT/UNMOUNT OK
window.NotificationsRoot = function(){
    let allElts = document.querySelectorAll('[data-react="notifications-container"]');
    for (const element of allElts) {
        const uniqueId = element.dataset.windowId || 'global';
        
        if (window.NotificationsRoots[uniqueId] && window.NotificationsRoots[uniqueId].unmount) {
            window.NotificationsRoots[uniqueId].unmount();
        }

        let attr = {};
        attr.windowId = uniqueId;
        attr.tasks = element.dataset.tasks ?? 0;
        attr.backyoupay = element.dataset.backyoupay ?? 0;
        

        const root = createRoot(element);
        root.render(<NotificationsRoot {...attr} />);

        window.NotificationsRoots[uniqueId] = root;
    }
}